import './style.scss';

import React, { useState, useCallback } from 'react';
import { Button } from 'reactstrap';

import PageContent from '../../../components/page-content';
import PageTitle from '../../../components/page-title';
import PageWrap from '../../../components/page-wrap';
import FormLayout from './components/form-layout';
import TabellaLayout from './components/tabella-layout';

const TotemLayout = () => {
  const [formStatus, setFormStatus] = useState(false);
  const [type, setType] = useState(undefined);
  const [id, setId] = useState(undefined);

  const changeFormStatus = useCallback(
    (newType = undefined, stato = undefined, newId = undefined) => {
      if (stato !== undefined) {
        setFormStatus(stato);
      } else {
        setFormStatus(prev => !prev);
      }
      setType(newType);
      setId(newId);
    },
    []
  );

  let button = <></>;
  let content = <></>;

  if (formStatus) {
    button = (
      <Button
        className="welcome-custom-btn"
        onClick={() => changeFormStatus(1)}
        color="brand"
      >
        Indietro
      </Button>
    );
    content = <FormLayout status={changeFormStatus} type={type} id={id} />;
  } else {
    button = (
      <Button
        className="welcome-custom-btn"
        onClick={() => changeFormStatus(1)}
        color="brand"
      >
        Nuovo Layout
      </Button>
    );
    content = <TabellaLayout status={changeFormStatus} />;
  }

  return (
    <PageWrap>
      <PageTitle
        breadcrumbs={{
          '/': 'Home',
        }}
      >
        <h1>Totem Layout</h1>
      </PageTitle>
      <PageContent>
        {button}
        <br />
        <br />
        {content}
      </PageContent>
    </PageWrap>
  );
};

export default TotemLayout;
